import { Theme } from "@mui/material";

export const getStepperStyles = (theme: Theme) => ({
  // Step connector line styles
  "& .MuiStepConnector-root": {
    "& > span": {
      display: "none"
    }
  },
  ".MuiStepConnector-lineVertical": {
    borderColor: theme.palette.primary.main,
  },

  // Step content card styles
  "& .MuiStepContent-root": {
    ml: { xs: 2, md: 3 }
  },
  "& .MuiCollapse-root": {
    transform: "translateY(-40px)",
    ml: 1,
  },

  // Step label styles
  "& .MuiStepLabel-root": {
    background: "transparent",
    paddingTop: 0,
    paddingBottom: 0,
    transition: "height 0.3s ease-in-out, opacity 0.3s ease-in-out",
    overflow: "hidden",
    height: "auto",
    opacity: 1
  },
  "& .MuiStepLabel-labelContainer": {
    ml: 1,
    pb: 3
  },

  // Step icon styles
  "& .MuiStepLabel-iconContainer": {
    alignSelf: "stretch",
  },
  ".MuiStepLabel-iconContainer": {
    "svg circle": {
      fill: theme.palette.primary.light,
    },
    "svg path": {
      fill: theme.palette.primary.main,
    },
    "span": {
      borderColor: theme.palette.primary.light,
    }
  },
  ".MuiStepLabel-iconContainer.Mui-active": {
    "svg circle": {
      fill: theme.palette.primary.main,
    },
    "span": {
      borderColor: theme.palette.primary.main,
    }
  },
  ".MuiStepLabel-iconContainer.Mui-completed": {
    "svg circle": {
      fill: theme.palette.primary.main,
    },
    "span": {
      borderColor: theme.palette.primary.main,
    }
  },
  ".MuiStepLabel-iconContainer.Mui-active svg path": {
    fill: "white",
  },
  ".MuiStepLabel-iconContainer.Mui-completed svg path": {
    fill: "white",
  },
});

export const getStepContentStyles = (theme: Theme, isLastStep: boolean) => ({
  "&.MuiStepContent-root": {
    borderLeft: isLastStep ? "none" : `1px solid ${theme.palette.primary.main}`,
  },
});
